/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_LaughInputs */

const fr_rapid_eager_otter_laugh = /** @type {(inputs: Rapid_Eager_Otter_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semaines`)
};

/**

* @param {Rapid_Eager_Otter_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_laugh = /** @type {((inputs?: Rapid_Eager_Otter_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_laugh(inputs)
});